import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Avatar from '@material-ui/core/Avatar';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary">
      {/* {"Copyright © "} */}
      <Link color="inherit" href="https://rwp.vercel.app/" target="_blank">
        Blog |
      </Link>{" "}
      <Link color="inherit" href="https://shopee.co.id/anggararedha" target="_blank">
        Store |
      </Link>{" "}
      <Link color="inherit" href="https://www.google.com/maps?q=-4.130679654370053,+104.20313736090462" target="_blank">
        Maps |
      </Link>{" "}
      <Link color="inherit" href="/tryout" target="_blank">
         LMS |
      </Link>{" "}
       <Link color="inherit" href="https://percetakan-rho.vercel.app/" target="_blank">
         Sablon |
      </Link>{" "}
      <Link color="inherit" href="https://brosur-gold.vercel.app/" target="_blank">
         Catalog |
      </Link>{" "}
       <Link color="inherit" href="https://undangan-online-phi.vercel.app/" target="_blank">
         Undangan Online
      </Link>
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2)
  },
  footer: {
    padding: theme.spacing(3, 2),
    marginTop: "auto",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800]
  }
}));

export default function StickyFooter() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* <CssBaseline /> */}
      <footer className={classes.footer}>
        <Container maxWidth="sm">
          <Typography variant="body1">
            Warung Angga
          </Typography>
          <Copyright /> 
        </Container>
      </footer>
    </div>
  );
}
